<template>
  <svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.2715 11L13.2715 15M13.2715 15L17.2715 19M13.2715 15H21.2715"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M7.27148 13L11.2715 9M11.2715 9L7.27148 5M11.2715 9H3.27148"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>
